<template>
    <div class="pt15">
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="100px;">
                    <col width="">
                    <col width="100px;">
                    <col width="">
                </colgroup>
                <tbody>
                    <tr>
                        <td class="c_t_title">배송지명</td>
                        <td colspan="3">
                            <el-input class="table_s_input mr10" v-model="title"></el-input>
                            <div class="input_error">{{ validation.firstError('title') }}</div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">수령인명</td>
                        <td>
                            <el-input class="table_s_input mr10" v-model="name"></el-input>
                            <div class="input_error">{{ validation.firstError('name') }}</div>
                        </td>
                        <td class="c_t_title">수령인 전화번호</td>
                        <td>
                            <el-input class="table_s_input mr10" v-model="phone"></el-input>
                            <div class="input_error">{{ validation.firstError('phone') }}</div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">배송지주소</td>
                        <td colspan="3">
                            <div class="d_block search">
                                <el-input class="table_s_input table_s_input_zipCode mr10" v-model="zipCode" readonly @focus="openDaumModal"></el-input>
                                <el-button type="primary" @click="openDaumModal">우편번호 검색 ></el-button>
                                <el-input class="mt10" v-model="address"></el-input>
                                <el-input class="mt10" v-model="addressDetail" @change="setData('addressDetail', addressDetail)"></el-input>
                                <div class="input_error">{{ validation.firstError('zipCode') }}</div>
                                <div class="input_error">{{ validation.firstError('address') }}</div>
                                <div class="input_error">{{ validation.firstError('addressDetail') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">배송 메모 선택</td>
                        <td colspan="3">
                            <div class="d_block">
                                <el-select
                                    class="select-memo"
                                    v-model="deliveryRequest"
                                    value-key="index"
                                    @change="setDeliveryRequestData('deliveryRequest', deliveryRequest)"
                                >
                                    <el-option
                                        v-for="(item, index) in deliveryRequests"
                                        :key="index"
                                        :label="item.od_name"
                                        :value="item.od_idx"
                                    >
                                    </el-option>
                                </el-select>
                                <div class="input_error">{{ validation.firstError('deliveryRequest') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="showMemo == true">
                        <td class="c_t_title">배송메모</td>
                        <td colspan="3">
                            <div class="d_block">
                                <el-input type="textarea" v-model="deliveryMemo" rows="5" @input="setData('deliveryMemo', deliveryMemo)"
                                        resize="none" placeholder="배송메시지를 입력해주세요."></el-input>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <daum-postcode-modal></daum-postcode-modal>
    </div>
</template>

<script>
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import numberHyphen from "@/mixins/numberHyphen"
import DaumPostcodeModal from "@/components/modal/DaumPostcodeModal.vue";

import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
const Validator = SimpleVueValidation.Validator;
import VuxAlert from '@/mixins/alertMixins';
Vue.use(SimpleVueValidation);

export default {
    name: "DeliveryWriteMemberComponent",
    mixins: [alertMixins,numberHyphen,VuxAlert],
    components: {DaumPostcodeModal},
    computed: {
    },
    provide() {
        return {
        }
    },
    props: {
        deliveryData:{default: () => []},
    },
    data() {
        return {
            isRunning: false,
            deliveryRequests: [],
            deliveryRequest: 0,
            deliveryRequestIdx: 0,
            showMemo: false,
            // 배송정보
            title: '',
            name: '',
            phone: '',
            zipCode:'',
            address:'',
            addressDetail:'',
            deliveryMemo:'', //od_is_text: 배송메모 필수 입력 유무 0:선택, 1:필수
        }
    },
    created() {
        this.initData()
        this.getDeliveryRequest()
    },
    mounted() {
        EventBus.$on('setAddress', this.setAddress);
        EventBus.$on('writeMemberDelivery', this.writeMemberDelivery)
    },
    beforeDestroy() {
        EventBus.$off('setAddress')
        EventBus.$off('writeMemberDelivery')
    },
    destroyed() {
    },
    methods: {
        initData(){
            this.title = this.deliveryData.md_title
            this.setData('title', this.title)
            
            this.name = this.deliveryData.md_receiver
            this.setData('name', this.name);

            this.phone = this.deliveryData.md_hp
            this.setData('phone', this.phone);

            this.zipCode = this.deliveryData.md_zipcode
            this.setData('zipCode', this.zipCode);

            this.address = this.deliveryData.md_addr1
            this.setData('address', this.address);

            this.addressDetail = this.deliveryData.md_addr2
            this.setData('addressDetail', this.addressDetail);
            
            this.deliveryMemo = this.deliveryData.md_memo
            this.setData('deliveryMemo', this.deliveryMemo);

            this.deliveryRequest = this.deliveryData.od_idx
            this.setData('deliveryRequest', this.deliveryRequest)
        },
        setData(type, value) {
            this[type] = value;
        },
        setDeliveryRequestData(type, value){
            this.deliveryRequestIdx = this.deliveryRequests.findIndex(item => item.od_idx === this.deliveryRequest);
            if (this.deliveryRequestIdx === -1) {
                return;
            }
            let necessaryText = this.deliveryRequests[this.deliveryRequestIdx].od_is_text;
            if(necessaryText == 0){
                this.showMemo = false
            } else if(necessaryText == 1){
                this.showMemo = true
            }
            this[type] = value; 
        },

        getDeliveryRequest() {
            try {
                this.$api.$member.getDeliveryCategory().then(res => res.Data.Result).then(res => {
                    if(!util.isEmpty(res.List)) {
                        this.deliveryRequests = res.List;
                        this.setDeliveryRequestData()
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },

        openDaumModal(){
            this.$modal.show('daum-postcode-modal');
        },
        setAddress(addrObj) {
            this.zipCode = addrObj.zonecode;
            this.address = addrObj.roadAddress;
            this.addressDetail = ''

            this.setData('zipCode', this.zipCode);
            this.setData('address', this.address);
        },

        _checkValidator() {
            let validatorArr = ['title', 'name', 'phone', 'zipCode','address','addressDetail','deliveryRequest','deliveryMemo'];
            return this.$validate(validatorArr).then(success => {
                return success
            });
        },
        _makeParams() {
            let params = {
                md_idx: this.deliveryData.md_idx, 
                md_title: this.title,
                md_receiver: this.name,
                md_hp: this.phone, 
                md_zipcode: this.zipCode,
                md_addr1: this.address, 
                md_addr2: this.addressDetail, 
                od_idx: this.deliveryRequest, 
                md_memo: this.deliveryMemo,
                mb_no: this.deliveryData.mb_no
            }
            return params;
        },
        async writeMemberDelivery(){
            if (this.isRunning) {
                return false;
            }
            this.isRunning = true;

            let validator = await this._checkValidator();

            if (!validator) {
                this.isRunning = false;
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();

            try {
                this.$api.$member.updateMemberDelivery(params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.Info.Type);
                    if (type === true) {
                        this.afterFunc();
                    } else {
                        this.errorAlert(type);
                        EventBus.$emit('changeLoading', false);
                        this.$modal.hide('member-delivery-modal');
                    }
                })
            } catch (e) {
                console.log(e)
                this.isRunning = false;
                EventBus.$emit('changeLoading', false);
            }
        },
        returnWriteType(type) {
            if (type === 1) {
                return true;
            } else if(type === -2) {
                return '저장에 실패하였습니다.'
            } else if(type === 100) {
                return '저장에 실패하였습니다.'
            } else if(type === -100) {
                return '저장에 실패하였습니다.'
            } else if(type === -103) {
                return '배송지 정보가 없습니다.'
            } else if(type === -113) {
                return '요청사항 카테고리가 없습니다.'
            } else {
                return '저장에 실패하였습니다.'
            }
        },
        afterFunc(){
            EventBus.$emit('changeLoading', false);
            this.createAlert({
                content: '저장하였습니다.',
                hide: () => {
                    this.$modal.hide('member-delivery-modal'); 
                    EventBus.$emit('getMemberDelivery')
                }
            })
        },       
    },
    watch: {},
    validators: {
        title: function (value) {
            return Validator.value(value)
            .required('배송지명을 입력해주세요.');
        },
        name: function (value) {
            return Validator.value(value)
            .required('수령인명을 입력하세요.');
        },
        phone: function (value) {
            return Validator.value(value)
            .required('수령인 전화번호를 입력하세요.')
            .minLength(10, '수령인 전화번호를 입력하세요.(숫자만)')
            .regex('^[0-9|]+$', '전화번호 형식이 잘못됐습니다.(숫자만)')
        },
        zipCode: function (value) {
            return Validator.value(value)
            .required('우편번호를 검색해주세요.');
        },
        address: function (value) {
            return Validator.value(value)
            .required('배송지 주소를 입력하세요.');
        },
        addressDetail: function (value) {
            return Validator.value(value)
            .required('배송지 상세 주소를 입력하세요.');
        },
        deliveryRequest: function (value) {
            return Validator.value(value)
        },
        deliveryMemo: function (value) {
            return Validator.value(value)
        },
    }
}
</script>

<style scoped>

</style>